<div class="container">
    <div class="row py-5 mb-5 px-2">
        <div class="col-md-3">
        </div>
        <div class="col-md-6">
            <div class="profile container w-100 h-100 border border-primary p-3 z-depth-2">
                <div class="header text-center position-relative border-bottom p-3">
                    <mdb-icon (click)="editAvatar = !editAvatar" fas icon="pen" class="edit fa-md m-2"></mdb-icon>
                    <div class="position-relative d-inline-block">
                        <img [src]="avatarUrl" class="profile-photo-lg">
                    </div>
                    <h1>{{user.name}}</h1>
                    <div class="account-data justify-content-center position-relative p-3 my-3">
                        <div *ngIf="!editStatusMessage" class="text-muted small"><em>{{(user.statusMessage && user.statusMessage !== null) ? user.statusMessage : "You don't have any status message"}}</em></div>
                        <div class="md-form text-center" *ngIf="editStatusMessage">
                            <textarea #statusInput rows="1" type="text" id="form7" class="md-textarea md-textarea-auto form-control w-100 mx-auto" mdbInput>{{user.statusMessage}}</textarea>
                        </div>
                        <mdb-icon (click)="onEditStatusMessage()" fas icon="pen" class="edit fa-md" [ngClass]="{'blue-text': editStatusMessage}"></mdb-icon>
                    </div>
                </div>
                <div class="account-data justify-content-center border-bottom position-relative p-3">
                    <mdb-icon fas icon="pen" (click)="onEditUser()" class="edit fa-md m-2" [ngClass]="{'blue-text': editUser}"></mdb-icon>
                    <form [formGroup]="form" class="">
                        <div class="md-form" [ngClass]="{'animated tada infinite slower': editUser && name.pristine}">
                            <input disabled mdbInput type="text" formControlName="name" id="name" class="form-control my-2 text-center">
                            <label for="name" class="">Name</label>
                            <span *ngIf="name && !name.valid && !name.disabled && name.dirty && name.touched" class="text-danger">Only A-Z characters allowed</span>
                        </div>
                        <div class="md-form" [ngClass]="{'animated tada infinite slower': editUser && email.pristine}">
                            <input disabled mdbInput type="email" formControlName="email" id="email" class="form-control my-2 text-center">
                            <label for="email" class="">E-mail</label>
                            <span *ngIf="email && !email.disabled && !email.valid && email.dirty && email.touched" class="text-danger">Please enter correct mail format</span>
                        </div>
                        <div class="md-form" [ngClass]="{'animated tada infinite slower': editUser && country.pristine}">
                            <select disabled formControlName="country" id="country" class="text-center">
                                <option value="" selected>{{translateCountry(user.country)}}</option>
                                <option *ngFor="let c of countries" [value]="c.value">{{c.text}}</option>
                              </select>
                            <label for="country" class="active">Country</label>
                        </div>
                    </form>
                </div>
                <div class="disorders-container position-relative p-1 text-center p-3 border-bottom">
                    <mdb-icon fas icon="pen" (click)="onEditDisorders()" class="edit fa-md m-2" [ngClass]="{'blue-text': editDisorders}"></mdb-icon>
                    <div class="mx-auto w-75">
                        <mdb-badge (click)="mark(d)" class="dbadge m-1" pill="true " *ngFor="let d of disorders" [ngClass]="{'animated heartBeat infinite slower': editDisorders, 'warning-color':d.isSelected, 'grey lighten-1' :!d.isSelected}">{{getDisorderValue(d)}}</mdb-badge>
                    </div>
                </div>
                <div class="text-center pt-3">
                    <p style="color:gray;"><u><a (click)="deleteAccountPopup = true">Delete account</a></u></p>
                </div>
            </div>
        </div>
        <div class="col-md-3">
        </div>
    </div>
</div>

<div class="overlay" *ngIf="editAvatar">
    <div class="row mx-1">
        <div class="col-md-3"></div>
        <div class="col-md-6 cropper-container my-md-5 my-2 border border-primary">
            <div class="custom-file my-2">
                <input type="file" accept="image/*" class="custom-file-input" id="customFile" (change)="handleFileInput($event)">
                <label class="custom-file-label text-left" for="customFile">{{file ? file.name : "Choose file"}}</label>
            </div>
            <image-cropper format="jpeg" [roundCropper]="true" (imageCropped)="imageCropped($event)" [imageChangedEvent]="imageChangedEvent"></image-cropper>
            <div class="preview text-center p-2">
                <img class="profile-photo animated rollIn" *ngIf="croppedImage" [src]="croppedImage">
            </div>
            <div class="text-center">
                <gb-action-button [isLoading]="isAvatarLoading" (onClick)="uploadAvatar()" [text]="'Upload'" [whenDisabled]="!file" [iconClass]="'cloud-upload-alt'"></gb-action-button>
                <gb-action-button (onClick)="editAvatar = false" [text]="'Cancel'"></gb-action-button>
            </div>
        </div>
        <div class="col-md-3"></div>
    </div>
</div>

<confirmation-popup [show]="showConfrimChange" [header]="'Email address change'" [message]="'We will send confirmation link to new email inbox. This operation will log you out of the account. Are you sure?'" (button1Action)="confirmChange()" [button1Text]="'Yes'"
    [button2Text]="'Cancel'" (button2Action)="cancelChange()">
    <loading-spinner></loading-spinner>
</confirmation-popup>

<confirmation-popup [show]="deleteAccountPopup" [header]="'Delete account'" [message]="'Are you sure you want to delete your account? This operation cannot be undone'" (button1Action)="confirmDelete()" [button1Text]="'Yes'" [button2Text]="'Cancel'" (button2Action)="deleteAccountPopup = false">
    <loading-spinner></loading-spinner>
</confirmation-popup>